module.exports = __webpack_public_path__ + "assets/img/nb-intro2.6f97fa5a.jpg";